<script lang="ts">
    import { linear } from 'svelte/easing'
    import { fly } from 'svelte/transition'
    import Fa from 'svelte-fa'
    import {
        faFileSignature,
        faShoppingCart,
        faUserCircle,
        faCalendarAlt,
        faChartLine,
        faUsers,
        faMoneyCheckAlt,
        faEllipsisH,
        faSun,
        faMoon,
    } from '@fortawesome/free-solid-svg-icons'
    import { ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'sveltestrap'
    import { Link, navigateTo, router } from 'yrv'
    import { onMount } from 'svelte'
    import { mobileBarVisible } from './stores'
    import AlertBar from './alert-bar.svelte'
    import Popover from './popover.svelte'
    import TemplateMobileMenu from './template-mobile-menu.svelte'
    import AlertPopup from './alert-popup.svelte'

    let showMenu = false
    let showBar = true
    // publica o estado para quem flutua acima da barra (ex.: botão "Agendar" da agenda)
    $: mobileBarVisible.set(showBar)
    let mobileBody

    // mesmo seletor de tema do menu da conta no desktop (template-master), com as mesmas classes
    // globais (.menu_theme em css_global.css) para os dois ficarem idênticos
    let currentTheme = 'theme_dark'
    async function setTheme(theme) {
        await window.api.utils.utils.setTheme(theme)
        currentTheme = theme
    }

    $: documentLink = window.configs?.documentVersionLatest ? '/customer-service-v2/forms' : '/customer-service/entries'

    function goShowMenu() {
        showMenu = true
    }

    let current = ''
    router.subscribe((e) => {
        current = '/' + location.href.split('/')[3]
    })

    function getScriptParam(param) {
        const scripts = document.getElementsByTagName('script') as any
        for (const script of scripts) {
            const qs = script.src.split('?')
            if (qs.length <= 1) {
                continue
            }
            const urlParams = new URLSearchParams('?' + qs[1])
            const result = urlParams.get(param)
            return result
        }
    }

    async function setMenu() {}

    async function evaluateHomePage() {
        if (location.pathname === '/') {
            navigateTo('/agenda/all')
            return
        }
    }

    let version = ''
    onMount(async () => {
        try {
            currentTheme = (await window.flags('theme', true)) || 'theme_dark'
            await setMenu()
            document.addEventListener(
                'scroll',
                (event) => {
                    evaluateMenuBar(event.target)
                },
                true,
            )
            version = getScriptParam('v')
            await evaluateHomePage()
        } catch (error) {}
    })

    let lastScroll = 0
    function evaluateMenuBar(el) {
        let scrollTop = el.scrollTop
        const isBottom = el.scrollTop >= el.scrollHeight - el.clientHeight - 10
        const isDown = scrollTop > lastScroll
        lastScroll = scrollTop
        if (!isDown || isBottom) {
            showBar = true
            return
        }
        if (isDown && scrollTop > 200) {
            showBar = false
            return
        }
    }
</script>

{#if showMenu}
    <Popover on:close={() => (showMenu = false)} title="Menu" width="100%">
        <TemplateMobileMenu on:click={() => (showMenu = false)}></TemplateMobileMenu>
    </Popover>
{/if}
<main>
    <AlertBar />
    <AlertPopup></AlertPopup>
    <div class="head">
        <div class="head-in">
            <div class="logo"><img src="/img/logo_full_white.png" alt="" /></div>
            <div class="drop-button">
                <ButtonDropdown>
                    <DropdownToggle color="link" class="link {current === '/conta' ? 'active' : ''}" caret
                        ><Fa icon={faUserCircle} /><span class="h-mobile">Conta</span></DropdownToggle
                    >
                    <DropdownMenu dark={true}>
                        <!-- <Link href="/conta/usuarios">
                        <DropdownItem>Usuários</DropdownItem>
                    </Link> -->
                        <Link href="/resources/password-change">
                            <DropdownItem>Alterar senha</DropdownItem>
                        </Link>
                        <Link href="/personalize/notifications">
                            <DropdownItem>Notificações</DropdownItem>
                        </Link>
                        <!-- <Link href="/conta/empresas">
                        <DropdownItem>Minhas empresas</DropdownItem>
                    </Link> -->
                        <Link href="/companies/select">
                            <DropdownItem>Acessar outra empresa</DropdownItem>
                        </Link>
                        <Link href="/resources/subscription">
                            <DropdownItem>Minha assinatura</DropdownItem>
                        </Link>

                        <DropdownItem divider />
                        <div class="menu_theme">
                            <div class="label">Tema</div>
                            <button on:click={() => setTheme('theme_light')} class="menu_them_item" class:menu_theme_active={currentTheme === 'theme_light'}
                                ><Fa icon={faSun}></Fa></button
                            >
                            <button on:click={() => setTheme('theme_dark')} class="menu_them_item" class:menu_theme_active={currentTheme === 'theme_dark'}
                                ><Fa icon={faMoon}></Fa></button
                            >
                        </div>
                        <DropdownItem divider />
                        <div on:click={window.logout}>
                            <DropdownItem>Sair</DropdownItem>
                        </div>
                        <div class="version">{version}</div>
                    </DropdownMenu>
                </ButtonDropdown>
            </div>
        </div>
    </div>
    <div class="body scroll-dark" bind:this={mobileBody}>
        <slot />
    </div>
    {#if showBar}
        <div class="bar" transition:fly={{ delay: 0, duration: 100, easing: linear, y: 50 }}>
            {#if window.store.token.permissions.dashboard.show}
                <Link class="link dash {current === '/dashboard' ? 'active' : ''}" href="/dashboard/home">
                    <div class="icon"><Fa icon={faChartLine} /></div>
                    <div class="label">Dash</div>
                </Link>
            {/if}
            {#if window.store.token.permissions.scheduler.show}
                <Link class="link agenda {current === '/agenda' ? 'active' : ''}" href="/agenda/all">
                    <div class="icon"><Fa icon={faCalendarAlt} /></div>
                    <div class="label">Agenda</div>
                </Link>
            {/if}
            {#if window.store.token.permissions.pos.show}
                <Link class="link pos {current === '/pos' ? 'active' : ''}" href="/pos/entries">
                    <div class="icon">
                        <Fa icon={faShoppingCart} />
                    </div>
                    <div class="label">PDV</div>
                </Link>
            {/if}
            {#if window.store.token.permissions.customerService.show}
                <Link class="link atendimento {current.startsWith('/customer-service') ? 'active' : ''}" href={documentLink}>
                    <div class="icon">
                        <Fa icon={faFileSignature} />
                    </div>
                    <div class="label">Atender</div>
                </Link>
            {/if}
            <div class="link persons" on:click={goShowMenu}>
                <div class="icon">
                    <Fa icon={faEllipsisH} />
                </div>
                <div class="label">Mais</div>
            </div>
        </div>
    {/if}
</main>

<style>
    main {
        background-color: rgb(22, 22, 22);
        color: rgb(238, 238, 238);
        height: 100vh;
        overflow: hidden;
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .head {
        background-color: #157c53;
        flex: 0 0 auto;
        display: flex;
        z-index: 997;
    }
    .head-in {
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 95%;
        max-width: 1600px;
        margin: 0 auto;
        flex-grow: 1;
        position: relative;
        padding: 8px 0px;
    }

    .head-in .drop-button {
        position: absolute;
        right: 4px;
    }

    .head :global(.link) {
        padding: 8px 10px 16px 10px;
        display: block;
        text-decoration: none;
        color: rgb(var(--menu-color));
        border-radius: 0px;
        border: 0px;
        text-shadow: 1px 1px 6px #ffffff33;
        margin-top: 8px;
    }
    .head :global(.dropdown-menu button) {
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .head :global(.active) {
        background: rgb(22, 22, 22);
        border-radius: 8px 8px 0px 0px;
    }
    .head :global(.link svg) {
        margin-right: 8px;
    }
    .head :global(.dash) {
        color: rgb(var(--dash-color));
    }
    .head :global(.pipeline) {
        color: rgb(var(--pipeline-color));
    }
    .head :global(.nps) {
        color: rgb(var(--nps-color));
    }
    .head :global(.agenda) {
        color: rgb(156, 77, 204);
    }
    .head :global(.pos) {
        color: rgb(var(--pos-color));
    }
    .head :global(.automacao) {
        color: rgb(var(--automacao-color));
    }
    .head :global(.indica) {
        color: rgb(var(--indica-color));
    }
    .head :global(.prospect) {
        color: rgb(var(--prospect-color));
    }
    .head :global(.publico) {
        color: rgb(var(--audience-color));
    }

    .head .logo {
        height: 40px;
        overflow: hidden;
        margin: 0px 24px 0px 8px;
        display: flex;
        align-items: center;
        width: 110px;
        flex-shrink: 0;
    }
    .head .logo img {
        height: 80%;
    }

    .body {
        overflow-y: auto;
        flex: 1 1 auto;
        max-height: 100%;
        border: 0px solid cyan;
    }
    .version {
        padding-right: 16px;
        color: #99999950;
        font-size: 12px;
        text-align: right;
    }

    .bar {
        display: flex;
        position: fixed;
        bottom: 0px;
        width: 100%;
        overflow: hidden;
    }
</style>
